import React from "react";
import { Clock } from "react-feather";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip as RechartsTooltip } from "recharts";
import { TimeTooltip } from "./ChartTooltips";
import styles from "../../maintenancerequest.module.css";

// data: [{ label, hours }]
const AvgCompletionChart = ({ data, loading }) => {
    const avgOverall = data.length
        ? (data.reduce((sum, t) => sum + (t.hours || 0), 0) / data.length).toFixed(1)
        : "0.0";

    return (
        <div className={`${styles.widgetCard}`}>
            <div className={`${styles.widgetHead}`}>
                <div className={`${styles.widgetTitleWrap}`}>
                    <div className={`${styles.widgetIcon} ${styles.wiOrange}`}>
                        <Clock size={16} />
                    </div>
                    <div>
                        <div className={`${styles.widgetTitle}`}>Avg. Completion Time</div>
                        <div className={`${styles.widgetSub}`}>By request type (hours)</div>
                    </div>
                </div>
                <div className={`${styles.widgetStat}`}>
                    {loading ? "-" : `${avgOverall}h`}
                    <span className={`${styles.widgetStatLabel}`}>avg overall</span>
                </div>
            </div>
            <div className={`${styles.chartBox}`}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={data} layout="vertical" margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                        <CartesianGrid horizontal={false} stroke="#f0f0f0" />
                        <XAxis
                            type="number"
                            tickLine={false}
                            axisLine={false}
                            tick={{ fontSize: 11, fill: "#8a8a95" }}
                            tickFormatter={(v) => `${v}h`}
                        />
                        <YAxis
                            type="category"
                            dataKey="label"
                            tickLine={false}
                            axisLine={false}
                            width={65}
                            tickMargin={2}
                            tick={{ fontSize: 11, fill: "#8a8a95" }}
                        />
                        <RechartsTooltip content={<TimeTooltip />} cursor={{ fill: "rgba(246,97,58,0.06)" }} />
                        <Bar dataKey="hours" fill="#f6613a" radius={[0, 6, 6, 0]} maxBarSize={20} />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default AvgCompletionChart;